// removed by extract-text-webpack-plugin
module.exports = {"root":"_3xtOhW8","fullScreen":"_1K-GwFQ"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/SeekApp/SeekApp.less
 ** module id = 615
 ** module chunks = 0
 **/